import React from 'react';
import './styles/Welcome.css';

export default function Welcome() {
  return <h1 className="welcome">Welcome to Weatherly</h1>;
}



// WEBPACK FOOTER //
// ./src/Welcome.js